module.exports = __webpack_public_path__ + "img/e-sign.c861aad6.png";